const url = "/tennis/api/SearchApi/Search";

export async function globalSearch(search: string) {
  try {
    const response = await fetch(
      `${process.env.HOST}${url}?searchString=${search}`,
      { mode: "no-cors" }
    );
    if (response.ok) {
      return await response.json();
    } else {
      throw Error(response.statusText);
    }
  } catch {
    throw Error("Something went wrong");
  }
}
